




import Vue from 'vue';
import Component from 'vue-class-component';

/**
 * Needed for "virtual routes".
 * E.g.
 * {
 *     path: '/parent'
 *     children: [{
 *         path: 'children'
 *         component: childrenComponent
 *     }]
 * }
 * You will see NOTHING if you access /parent/children if you dont specify this component to the parent.
 */
@Component
export default class EmptyRouterTemplate extends Vue {

}
